import {
  Grid,
  ListItem,
  Theme,
  Tooltip,
  Typography,
  withStyles,
  WithStyles
} from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';
import { Link } from '@material-ui/icons';
import classnames from 'classnames';
import moment from 'moment';
import * as React from 'react';
import MyButton from '../../components/UI/MyButton/MyButton';
import { IAsset, IFeed } from '../../models/states';
import AssetHistory from './AssetHistory';
const styles = (theme: Theme) =>
  createStyles({
    root: {},
    actionButtons: {
      marginRight: '1rem'
    },
    link: { textDecoration: 'none', display: 'flex' },
    lightTooltip: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: theme.shadows[1],
      fontSize: 11
    },
    blur: {
      filter: 'blur(2px)'
    }
  });
class AssetSummary extends React.Component<IAssetSummary, {}> {
  renderGridItem = (label: string, value: any, blur: boolean = false) => {
    return (
      <ListItem>
        <Grid item xs={3}>
          <Typography>{label}</Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography
            className={classnames({ [this.props.classes.blur]: blur })}
          >
            {value}
          </Typography>
        </Grid>
      </ListItem>
    );
  };
  public render() {
    const { asset, classes } = this.props;
    const blur = globalThis.UI_CONFIG.blur_data;
    return (
      <div>
        <Grid container>
          {this.renderGridItem('Title', asset.title, blur)}
          {this.renderGridItem('Asset Id', asset.assetId, blur)}
          {this.renderGridItem('Customer', asset.customer, blur)}
          {this.renderGridItem('State', asset.state)}
          {this.renderGridItem('Type', asset.mediaType)}

          <ListItem>
            <Grid item xs={3}>
              <Typography>Channel Name</Typography>
            </Grid>
            <Grid item xs={9}>
              <Typography
                className={classnames({ [this.props.classes.blur]: blur })}
              >
                {asset.feeds.map((feedCode: string, index: number) => {
                  const feedObj = this.props.feedMap[
                    `${feedCode}#${asset.customer}`
                  ];
                  const feedName = feedObj ? feedObj.name : feedCode;
                  const timezone = feedObj ? feedObj.timezone : '';
                  return (
                    <Tooltip
                      interactive
                      classes={{ tooltip: classes.lightTooltip }}
                      title={timezone}
                      placement={'bottom-start'}
                      key={index}
                    >
                      <span key={index}>
                        {index === asset.feeds.length - 1
                          ? feedName
                          : `${feedName}, `}
                      </span>
                    </Tooltip>
                  );
                })}
              </Typography>
            </Grid>
          </ListItem>

          {this.renderGridItem('Status', asset.status ? asset.status : 'NA')}
          {this.renderGridItem(
            'Created At',
            asset.createdAt
              ? moment(asset.createdAt).format('YYYY-MM-DD  HH:mm:ss')
              : 'NA'
          )}
          {this.renderGridItem(
            'Updated At',
            asset.createdAt
              ? moment(asset.updatedAt).format('YYYY-MM-DD  HH:mm:ss')
              : 'NA'
          )}
          {this.renderGridItem(
            'State Error Message',
            asset.stateErrorMessage ? asset.stateErrorMessage : 'NA'
          )}
          {/* {this.props.isOperator
            ? null
            : this.renderGridItem(
                'Ticket Id',
                asset.issueTrackerId ? (
                  <a
                    href={`${globalThis.UI_CONFIG.issue_tracker_url}/${asset.issueTrackerId}`}
                    target="_blank"
                    className={classes.link}
                  >
                    <Typography>{asset.issueTrackerId}</Typography>
                    <Link style={{ paddingBottom: 5, color: '#fff' }} />
                  </a>
                ) : (
                  'NA'
                )
              )} */}
          {globalThis.UI_CONFIG &&
          globalThis.UI_CONFIG.disable_issue_tracker ? null : (
            <ListItem>
              <Grid item xs={3}>
                <Typography>Actions</Typography>
              </Grid>
              <Grid
                item
                xs={9}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                {asset.issueTrackerId ? //  &&
                // asset.issueTrackerStatus !== 'close'
                null : (
                  <MyButton
                    className={classes.actionButtons}
                    onClick={this.props.onOpenEscalateForm}
                    btnType="yellow"
                  >
                    Escalate
                  </MyButton>
                )}
                {!this.props.isOperator ? (
                  <React.Fragment>
                    {asset.status === 'snoozed' ||
                    asset.status === 'pending' ? null : (
                      <MyButton
                        className={classes.actionButtons}
                        btnType="yellow"
                        onClick={this.props.onOpenSnoozeForm}
                      >
                        Snooze
                      </MyButton>
                    )}

                    {asset.issueTrackerId ? (
                      // &&
                      // asset.issueTrackerStatus !== 'close'
                      <a
                        href={`${globalThis.UI_CONFIG.issue_tracker_url}/${asset.issueTrackerId}`}
                        target="_blank"
                        className={classes.link}
                      >
                        <Typography>{asset.issueTrackerId}</Typography>
                        <Link style={{ paddingBottom: 5, color: '#fff' }} />
                      </a>
                    ) : null}
                  </React.Fragment>
                ) : null}
              </Grid>
            </ListItem>
          )}
          <ListItem>
            <Grid item xs={12}>
              <Typography>History</Typography>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid item xs={12} style={{ marginTop: '-2rem' }}>
              <AssetHistory asset={asset} />
            </Grid>
          </ListItem>
        </Grid>
      </div>
    );
  }
}
interface IAssetSummaryOwnProps extends WithStyles<typeof styles> {
  asset: IAsset;
  isOperator: boolean;
  onOpenEscalateForm: () => any;
  onOpenSnoozeForm: () => any;
  onOpenResolveForm: () => any;
  feedMap: { [key: string]: IFeed };
}
type IAssetSummary = IAssetSummaryOwnProps;
export default withStyles(styles)(AssetSummary);
